import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
} from '@material-ui/icons';
import { SvgIcon } from '@material-ui/core';

import { LockIcon, UnlockIcon } from '../icon/solid';
import { CopyIcon } from '../icon/regular';

const Icons = {
  default: SvgIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  copy: CopyIcon,
  custom: SvgIcon,
  lock: LockIcon,
  unlock: UnlockIcon,
};

export default Icons;
